





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { imageUploadApi } from '../services/webAssistantImageUpload';
import Toast from '@/shared/services/toast';

@Component
export default class WebAssistantImageUpload extends Vue {
	@Prop() public accept: string;
	@Prop() public previewWidth: number;
	@Prop() public previewHeight: number;
	@Prop() public image: string;
	@Prop() public disabled: boolean;

	public imageUploaded = false;
	public imageUrl = '';
	public uploading = false;

	public inputElement: HTMLInputElement;

	@Watch('image', {immediate: true})
	public onImageUrlChanged(value: string, previous: string) {
		if (value) {
			this.imageUploaded = true;
			this.imageUrl = value;
		}
	}

	public emitSelected() {
		this.$emit('selected');
	}

	public emitUploaded(url: string) {
		this.$emit('uploaded', url);
	}

	public emitCleared() {
		this.$emit('cleared');
	}

	public imageSelected(e: Event) {
		if (this.disabled) {
			return;
		}

		this.inputElement = e.target as HTMLInputElement;
		if (!this.inputElement.files || this.inputElement.files.length === 0) {
			return;
		}

		const selectedFile = this.inputElement.files[0];
		if (!this.isValidFileType(selectedFile.type)) {
			Toast.showError(`Invalid file type - accepted types are .png, .jpg or .jpeg`);
			this.inputElement.value = '';
			return;
		}

		this.emitSelected();

		this.uploading = true;

		imageUploadApi.upload(selectedFile)
			.then(response => {
				this.imageUploaded = true;
				this.imageUrl = response.url;
				this.emitUploaded(response.url);
				Toast.showSuccess('Image uploaded successfully');
			})
			.catch(err => {
				// clear the file from the input
				// fixes issue where nothing happens if the
				// user goes to select the same image again
				this.inputElement.value = '';
				Toast.showError(err.message);
				this.emitCleared();
			})
			.finally(() => {
				this.uploading = false;
			});
	}

	public clearImage() {
		this.imageUrl = '';
		if (this.inputElement) {
			this.inputElement.value = '';
		}
		this.imageUploaded = false;
		this.emitCleared();
	}

	private isValidFileType(type: string) {
		return type === 'image/png' || type === 'image/jpeg';
	}
}
